// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.managecard-head {
  font-weight: 400;
  font-size: 14px;
  color: #68ad3f;
}

.managecard-descr {
  font-weight: 400;
  font-size: 12px;
  color: #787878;
}
.web-trans-list-org {
  display: flex;
  align-items: center;
  width: 81%;
}
.managecard,.managecardDisabled {
  width: calc(33.33% - 12px); 
  height: 60px;
  margin-bottom: 18px;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  align-items: center;
  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  cursor: pointer;
}
.managecard{
  background: #ffffff;
}

.managecardDisabled{
  background: #ffffff;
  opacity:0.3;
  pointer-events: none;
}
.managecard-list {
  display: flex;
  flex-wrap: wrap;
  column-gap: 18px;
}

.org-body-title {
  font-weight: 500;
  font-size: 22px;
  color: #424242;
}
.manage-img {
  height: 36px;
  width: 36px;
}

.web-btn-org {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #68ad3f;
  min-width: 134px !important;
  overflow-wrap: anywhere;
}

@media only screen and (min-width: 481px) and (max-width: 767px) {
  .web-trans-list-org {
    display: none;
  }
  .web-btn-org {
    display: none !important;
  }
}
@media only screen and (min-width: 0px) and (max-width: 481px) {
  .managecard,.managecardDisabled {
    width: 100%;
  }
  .web-trans-list-org {
    display: none;
  }
  .web-btn-org {
    display: none !important;
  }
  .managecard-head {
    font-size: 12px;
  }
  /* .event-img {
    display: none;
  } */

  .managecard-descr {
    font-size: 10px;
  }
  .org-body-title {
    font-size: 20px;
  }
}

@media only screen and (min-width: 481px) and (max-width: 767px) {
  .managecard,.managecardDisabled{
    width: calc(50% - 10px);
  }
  .managecard-head {
    font-size: 12px;
  }
  .managecard-descr {
    font-size: 10px;
  }
  .org-body-title {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .managecard,.managecardDisabled {
    width: calc(50% - 10px);
  }
  .managecard-head {
    font-size: 12px;
  }
  .managecard-descr {
    font-size: 10px;
  }
  .org-body-title {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Organizer/ManageFeisGrade/ManageFeisGrade.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;;KAEG;;EAEH;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".managecard-head {\n  font-weight: 400;\n  font-size: 14px;\n  color: #68ad3f;\n}\n\n.managecard-descr {\n  font-weight: 400;\n  font-size: 12px;\n  color: #787878;\n}\n.web-trans-list-org {\n  display: flex;\n  align-items: center;\n  width: 81%;\n}\n.managecard,.managecardDisabled {\n  width: calc(33.33% - 12px); \n  height: 60px;\n  margin-bottom: 18px;\n  border-radius: 4px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.managecard{\n  background: #ffffff;\n}\n\n.managecardDisabled{\n  background: #ffffff;\n  opacity:0.3;\n  pointer-events: none;\n}\n.managecard-list {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 18px;\n}\n\n.org-body-title {\n  font-weight: 500;\n  font-size: 22px;\n  color: #424242;\n}\n.manage-img {\n  height: 36px;\n  width: 36px;\n}\n\n.web-btn-org {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  color: #68ad3f;\n  min-width: 134px !important;\n  overflow-wrap: anywhere;\n}\n\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .web-trans-list-org {\n    display: none;\n  }\n  .web-btn-org {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 0px) and (max-width: 481px) {\n  .managecard,.managecardDisabled {\n    width: 100%;\n  }\n  .web-trans-list-org {\n    display: none;\n  }\n  .web-btn-org {\n    display: none !important;\n  }\n  .managecard-head {\n    font-size: 12px;\n  }\n  /* .event-img {\n    display: none;\n  } */\n\n  .managecard-descr {\n    font-size: 10px;\n  }\n  .org-body-title {\n    font-size: 20px;\n  }\n}\n\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .managecard,.managecardDisabled{\n    width: calc(50% - 10px);\n  }\n  .managecard-head {\n    font-size: 12px;\n  }\n  .managecard-descr {\n    font-size: 10px;\n  }\n  .org-body-title {\n    font-size: 20px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .managecard,.managecardDisabled {\n    width: calc(50% - 10px);\n  }\n  .managecard-head {\n    font-size: 12px;\n  }\n  .managecard-descr {\n    font-size: 10px;\n  }\n  .org-body-title {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
